import { render, staticRenderFns } from "./popup-bind-she-bei.vue?vue&type=template&id=cb7611cc&scoped=true"
import script from "./popup-bind-she-bei.vue?vue&type=script&lang=js"
export * from "./popup-bind-she-bei.vue?vue&type=script&lang=js"
import style0 from "./popup-bind-she-bei.vue?vue&type=style&index=0&id=cb7611cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb7611cc",
  null
  
)

export default component.exports